<script lang="ts" setup>
import { NuxtUiIcons } from '@shared/types'

const props = withDefaults(
  defineProps<{
    isOnTop?: boolean
    keyValue?: string
    labelValue?: string
    placeholder?: string
    isGreenVariant?: boolean
    isOutlineVariant?: boolean
    modelValue?: string | number
    options?: Array<Record<string, any> | number | string>
  }>(),
  {
    modelValue: '',
    options: () => [],
    placeholder: '',
    keyValue: 'value',
    labelValue: 'display'
  }
)

const emit = defineEmits<{
  'update:modelValue': [state: any]
}>()

const selectorOptions = computed(() =>
  props.options.map((option) => {
    if (typeof option !== 'object') {
      return {
        display: option,
        value: option
      }
    }

    return {
      display: option[props.labelValue],
      value: option[props.keyValue]
    }
  })
)

const selectedOption = computed(() =>
  selectorOptions.value.find((option) => option.value === props.modelValue)
)

function onModelValueChange(value: string | number) {
  emit('update:modelValue', value)
}
</script>

<template>
  <USelectMenu
    :popper="{ placement: 'bottom-start' }"
    :model-value="modelValue"
    :options="selectorOptions"
    :placeholder="placeholder"
    :value-attribute="keyValue"
    :option-attribute="labelValue"
    :ui="{ wrapper: isOnTop ? '' : 'max-sm:w-full' }"
    :ui-menu="{
      width: 'w-auto min-w-full',
      option: {
        base: 'font-medium',
        size: 'text-sm'
      }
    }"
    @update:model-value="onModelValueChange"
  >
    <template #default="{ open }">
      <UButton
        class="w-full flex justify-between"
        variant="ghost"
        color="sky"
        size="sm"
      >
        <span>
          {{ selectedOption?.display || placeholder }}
        </span>
        <UIcon
          :name="NuxtUiIcons.ChevronDown"
          class="size-4 transition-transform"
          :class="[open ? 'rotate-180' : '']"
        />
      </UButton>
    </template>
  </USelectMenu>
</template>
